module.exports = __webpack_public_path__ + "static/media/nutrition-primary.d61f709c.jpg";